var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#112154"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m62 8v72h-14v-36h-40v76h76v-26h36v-2h0.19922v-84zm-50 40h14v8h4v-8h14v32h-32zm32 68h-32v-32h14v8h4v-8h14zm36 0h-32v-32h14v10h18zm36.199-26h-50.199v-78h50.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86 24h26v4h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86 44h26v4h-26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86 64h16v4h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.578 29.422 1.4219 1.3984 1.4219-1.3984 8-8-2.8438-2.8438-6.5781 6.6016-2.5781-2.6016-2.8438 2.8438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.578 49.422 1.4219 1.3984 1.4219-1.3984 8-8-2.8438-2.8438-6.5781 6.6016-2.5781-2.6016-2.8438 2.8438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.578 69.422 1.4219 1.3984 1.4219-1.3984 8-8-2.8438-2.8438-6.5781 6.6016-2.5781-2.6016-2.8438 2.8438z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2_성분패키지.3e5eb373dfd755ec4c49bdc436b1b9b1.svg";
export { ForwardRef as ReactComponent };